import { Component, OnInit,  Input, Output, EventEmitter} from '@angular/core';
import {  UntypedFormGroup } from '@angular/forms';
import { CampsDetailsFormStateService } from '../../../../../camp-details-form-state-service';

@Component({
    selector: 'app-day-variant-details',
    templateUrl: './day-variant-details.component.html',
    styleUrls: ['./day-variant-details.component.scss'],
    standalone: false
})
export class DayVariantDetailsComponent implements OnInit {
  
    @Input() public form : UntypedFormGroup;

    @Output() removed: EventEmitter<UntypedFormGroup> = new EventEmitter();

    constructor(public state : CampsDetailsFormStateService) { 

    }

    ngOnInit(): void {
   
    }

    public get isOtherItemEdited(){
        return this.state.isOtherItemEdited(this.form);
    }


    public edit(){
        this.state.markAsEdited(this.form);
    }

    public remove(){
         this.removed.emit(this.form)
    }
}
